import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDino: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dino, age, old"><path d="M16 10.5C8.96912 6.22033 7.17125 9.97708 5.46456 13.5433C4.54613 15.4624 3.65411 17.3263 1.98719 17.853C1.46057 18.0194 1 18.4477 1 19C1 19.5523 1.44771 20 2 20H6C6 21.1046 6.89543 22 8 22C9.10457 22 10 21.1046 10 20H13C13 21.1046 13.8954 22 15 22C16.1046 22 17 21.1046 17 20V19.1973C18.7934 18.1599 20 16.2208 20 14V7.11803C20 6.73926 20.214 6.393 20.5528 6.22361L21.581 5.70948C21.8378 5.5811 22 5.3144 22 5.02733C22 3.37047 20.6569 2 19 2C17.3431 2 16 3.34315 16 5V10.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconDino;
